import { useState } from 'react';
import { Link, useSearchParams, useNavigate } from 'react-router-dom';
import { Button } from '../components/ui/button';
import { Input } from '../components/ui/input';
import { Label } from '../components/ui/label';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '../components/ui/card';
import { axiosInstance } from '../App';
import { toast } from 'sonner';
import { Store } from 'lucide-react';

export default function Login({ onLogin }) {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    
    try {
      const res = await axiosInstance.post('/auth/login', { username, password });
      const redirectUrl = searchParams.get('redirect');
      onLogin(res.data.token, res.data.user, redirectUrl);
      toast.success('Giriş başarılı!');
    } catch (err) {
      toast.error(err.response?.data?.detail || 'Giriş başarısız');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-blue-400 via-purple-500 to-pink-500 p-4">
      <Card className="w-full max-w-md shadow-2xl border-0 overflow-hidden" data-testid="login-card">
        <CardHeader className="text-center space-y-4">
          <div className="mx-auto w-16 h-16 rounded-2xl bg-gradient-to-br from-purple-500 to-pink-500 flex items-center justify-center shadow-lg">
            <Store className="w-10 h-10 text-white" />
          </div>
          <CardTitle className="text-3xl font-bold bg-gradient-to-r from-purple-600 to-pink-600 bg-clip-text text-transparent">
            Hoşgeldiniz
          </CardTitle>
          <CardDescription className="text-base">Hesabınıza giriş yapın</CardDescription>
        </CardHeader>
        <CardContent>
          <form onSubmit={handleSubmit} className="space-y-4">
            <div className="space-y-2">
              <Label htmlFor="username">Kullanıcı Adı</Label>
              <Input
                id="username"
                type="text"
                placeholder="kullaniciadi"
                value={username}
                onChange={(e) => setUsername(e.target.value)}
                required
                className="h-11"
                data-testid="username-input"
              />
            </div>
            <div className="space-y-2">
              <Label htmlFor="password">Şifre</Label>
              <Input
                id="password"
                type="password"
                placeholder="••••••••"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
                className="h-11"
                data-testid="password-input"
              />
            </div>
            <Button 
              type="submit" 
              className="w-full h-11 bg-gradient-to-r from-purple-500 to-pink-500 hover:from-purple-600 hover:to-pink-600 text-white font-semibold shadow-lg hover:shadow-xl transition-all"
              disabled={loading}
              data-testid="login-submit-button"
            >
              {loading ? 'Giriş yapılıyor...' : 'Giriş Yap'}
            </Button>
          </form>
          <div className="mt-4 text-center space-y-2">
            <div>
              <Link to="/forgot-password" className="text-sm text-purple-600 hover:text-purple-700" data-testid="forgot-password-link">
                Şifremi Unuttum?
              </Link>
            </div>
            <div>
              <Link to="/resend-verification" className="text-sm text-blue-600 hover:text-blue-700">
                Email Doğrulama Linki Gönder
              </Link>
            </div>
          </div>
          <p className="text-center mt-6 text-sm text-gray-600">
            Hesabınız yok mu?{' '}
            <Link 
              to={searchParams.get('redirect') ? `/register?redirect=${searchParams.get('redirect')}` : '/register'} 
              className="text-purple-600 hover:text-purple-700 font-semibold" 
              data-testid="register-link"
            >
              Kayıt Ol
            </Link>
          </p>
        </CardContent>
      </Card>
    </div>
  );
}
